<template>
  <div class="app-header" :style="{ height: height + 'px' }">
    <div class="app-header-container" ref="header">
      <div class="app-header-title" @click="goHome()">
        <img class="app-header-logo" src="@/assets/img/logo.png" alt="" />
        <span class="app-header-name">皖教云</span>
        <!-- <span class="app-header-name">安徽中小学智慧教育平台·皖教云</span> -->
        <span
          class="app-header-module"
          v-if="showModule"
          @click="$router.push('/')"
          >教研新空间</span
        >
      </div>
      <ul class="nav">
        <li v-for="(item, index) in headerArray" :key="index">
          <div
            class="link"
            @mouseenter="hoverIndex = index"
            @mouseleave="hoverIndex = viewIndex"
            :class="{ active: hoverIndex === index }"
            @click="linkClick(item)"
          >
            {{ item.name }}
          </div>
          <div
            :class="[
              'nav-item-list',
              { listGLZX: index === 4 },
              { show: hoverIndex === index },
            ]"
            @mouseenter="hoverIndex = index"
            @mouseleave="hoverIndex = viewIndex"
          >
            <div
              v-for="child in item.childItem"
              :key="child.index"
              :class="[
                { itemActive: hoverChildIndex === child.index },
                { itemGLZX: index === 4 },
              ]"
              @mouseenter="hoverChildIndex = child.index"
              @mouseleave="hoverChildIndex = -1"
              @click="handleClick(child)"
            >
              {{ child.name }}
            </div>
          </div>
        </li>
      </ul>
      <AvatarDropdown class="right-login" />
      <!-- <div class="right-login">
        <el-dropdown @command="handleCommand" v-if="loginStatus">
          <div class="app-header-user">
            <img
              v-if="userInfo.photo && userInfo.photo.length > 0"
              class="app-header-avatar"
              :src="userInfo.photo"
            />
            <div class="app-header-username">
              {{ userInfo.userName | splitName }}
            </div>
            <i class="app-header-dropdown el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div v-else class="login" @click="login">登录</div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AvatarDropdown from '../layouts/AvatarDropdown.vue'
// const {
//   VUE_APP_APPNAME,
//   VUE_APP_APPKEY,
//   VUE_APP_SSOSERVERURL,
//   VUE_APP_LOGINREDIRECTURL
// } = process.env
// let edusso = new EduSSO();
export default {
  components: { AvatarDropdown },
  props: {
    showMenu: {
      type: Boolean,
      default: false,
    },
    showModule: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      height: 0,
      linkList: window.APP_CONFIG.menuLink,
      // userInfo: {},
      // userPhoto: "",
      viewIndex: -1,
      hoverIndex: -1, // 高亮的一级菜单
      childIndex: "",
      headerArray: [],
      hoverChildIndex: 0, // 高亮的二级菜单
    };
  },
  created () {
    this.headerArray = window.commonNav;
  },
  // filters: {
  //   splitName (name) {
  //     if (name) {
  //       if (name.length > 4) {
  //         return `${name.substring(0, 4)}..`;
  //       } else {
  //         return name;
  //       }
  //     }
  //   },
  // },
  mounted () {
    this.getHeight();
    this.init();
  },
  computed: {
    ...mapState({
      loginStatus: state => state.loginStatus,
      userInfo: state => state.userInfo
    }),
    // ...mapGetters(["is_login"]),
  },
  methods: {
    goHome () {
      let url = this.headerArray[0].href;
      window.open(url, "_self");
    },
    // ...mapActions(["checkLoginWithSSO"]),
    init () {
      window.addEventListener("load", this.getHeight);
      window.addEventListener("resize", this.getHeight);
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("load", this.getHeight);
        window.removeEventListener("resize", this.getHeight);
      });
      // // SSO配置
      // window.SSO.appName = VUE_APP_APPNAME
      // window.SSO.appKey = VUE_APP_APPKEY
      // window.SSO.SSOServerUrl = VUE_APP_SSOSERVERURL
      // window.SSO.loginRedirectUrl = VUE_APP_LOGINREDIRECTURL
      // // 登录状态
      // window.SSO.getLoginState((res) => {
      //   console.log(res)
      //   const isLogin = res.code === 1001
      //   // this.checkLoginWithSSO(isLogin)
      //   // commit('LOGIN_STATE', isLogin)
      //   if (isLogin) {
      //     window.localStorage.setItem('st', res.data.st)
      //     window.localStorage.setItem('tgt', res.data.tgt)
      //     this.getUserInfo();
      //     // dispatch('GetUserInfo') // 获取用户信息
      //   }
      // })
      // window.SSO.client = "web";
      // //TODO 根据实际应用使用的appKey标识填写
      // window.SSO.mac = window.SSO.deviceId;
      // window.SSO.customLogoutUrl = "";
      // window.SSO.needAttribute = true;
      // window.SSO.SSOServerUrl = process.env.VUE_APP_SSO_URL;
      // window.SSO.SSOCenterServerUrl = process.env.VUE_APP_SSO_URL;
      // window.SSO.loginRedirectUrl = "";
      // window.SSO.isCenterSSO = true;
      // window.SSO.accountTypeIsAuto = true;
      // window.SSO.needToken = true;
      // window.SSO.appKey = "8a1061d2a87344dd87e3b6e8ed10ac32";

      // SSO.getAccessToken((res) => {
      //   if (res.code === "1") {
      //     // localStorage.setItem("token", res.data.token);
      //     // localStorage.setItem("clientType", window.APP_CONFIG.clientType); // 配置文件
      //     // localStorage.setItem("deviceId", SSO.deviceId);
      //     // localStorage.setItem("appKey", window.APP_CONFIG.appKey); // 配置文件
      //     this.getUserInfo(res.data.userId);
      //   }
      //   res.code === "1"
      //     ? this.checkLoginWithSSO(true)
      //     : this.checkLoginWithSSO(false);
      // });
    },
    gotoPage (link, index) {
      if (!this.loginStatus && [4, 8, 9].includes(index)) {
        this.$message.warning("请登录");
        return;
      }
      if (link != "") {
        window.open(link, "_blank");
      }
    },
    // // 获取登录信息
    // async getUserInfo (userId) {
    //   try {
    //     let req = {
    //       userId,
    //     };
    //     let { code, data } = await this.$api.user.getUserName(req);
    //     if (code === "1") {
    //       this.userInfo = data;
    //       let loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
    //       if (
    //         !this.userInfo.photo &&
    //         loginUser &&
    //         loginUser.avatar &&
    //         loginUser.avatar.avatar_small
    //       ) {
    //         this.userInfo.photo = loginUser.avatar.avatar_small;
    //       }
    //     }
    //   } catch (error) {
    //     this.userInfo = {};
    //   }
    // },
    getHeight () {
      this.height = this.$refs.header.clientHeight;
    },
    // handleCommand (val) {
    //   this[val]();
    // },
    // login () {
    //   window.open(process.env.VUE_APP_LOGINREDIRECTURL, "_blank");
    //   // window.location.href = this.headerArray[0].loginUrl;
    // },
    // async logout () {
    //   await SSO.logout(() => {
    //     localStorage.clear();
    //     this.$store.commit('SET_LOGINSTATUS', false)
    //     // this.checkLoginWithSSO(false);
    //   });
    //   // edusso.logout(() => {
    //   //   window.location.reload();
    //   // });
    // },
    /**
     * @description: 临时使用，针对两个特殊账号
     * 真正跳转的时候，判断是否有其他链接且判断一下登陆状态，如果已登录且有登陆后的链接，则跳转到新链接
     * @param {object} item
     */
    goHref (item) {
      let realHref = item.href;
      let hasAccounts = item.accounts && item.accounts.length;
      if (
        item.afterLoginHref &&
        this.loginStatus &&
        hasAccounts &&
        item.accounts.includes(this.userInfo.userId)
      ) {
        realHref = item.afterLoginHref;
      }
      window.open(realHref, "_blank");
    },
    handleClick (item) {
      this.hoverChildIndex = 0;
      if (item.reload) {
        this.reload();
      } else if (item.needLogin) {
        this.needLogin(item.href);
      } else {
        this.hoverIndex = -1;
        this.childIndex = "";

        this.goHref(item);
      }
    },
    linkClick (item) {
      if (item.href && item.href.length > 0) {
        this.goHref(item);
      }
    },
    needLogin (href) {
      if (this.loginStatus) {
        this.hoverIndex = -1;
        window.open(href, "_blank");
      } else {
        this.$message({
          message: "请登录",
          type: "warning",
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
.app-header-container {
  z-index: 100;
  position: sticky;
  top: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0 14px;
  height: 56px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.08);
  .app-header-title {
    cursor: pointer;
    flex-shrink: 0;
    justify-items: space-between;
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: bold;
    color: @dark-blue;
    line-height: 36px;
    margin-right: 14px;
    .app-header-logo {
      width: 67px;
      height: 40px;
      margin-right: 7px;
      line-height: 36px;
    }
    .app-header-module {
      cursor: pointer;
      &::before {
        content: "";
        display: inline-block;
        margin: 0 16px;
        width: 2px;
        height: 20px;
        background: @dark-blue;
        box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.08);
      }
    }
  }
  .app-header-menu {
    // display: flex;
    flex: 1;
    .app-header-link {
      font-size: 16px;
      font-weight: 400;
      color: #000;
      padding: 0 11px 2px 11px;
      word-break: keep-all;
      &.active {
        color: @light-blue;
      }
      &:hover {
        color: #368fff;
      }
    }
  }
  .app-header-user {
    display: flex;
    align-items: center;
    margin-left: 24px;
    .app-header-avatar {
      margin-right: 8px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      overflow: hidden;
      box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.08);
    }
    .app-header-username {
      font-size: 14px;
      color: @dark-text;
      line-height: 21px;
    }
    .app-header-dropdown {
      margin-left: 8px;
    }
  }
}
.nav {
  display: inline-block;
  position: relative;
  vertical-align: top;
  li {
    line-height: 56px;
    height: 56px;
    display: inline-block;
    width: 144px;
    text-align: center;
    position: relative;
    .link {
      padding: 0 5px;
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      cursor: pointer;
      display: block;
      &.active {
        color: #368fff;
      }
      &:active {
        color: #368fff;
      }
    }
    &:first-child {
      width: 80px;
      // .link {
      //   color: #368fff;
      // }
    }
    &:nth-child(3) {
      .link {
        color: #368fff;
      }
    }
    .nav-item-list {
      z-index: 2000;
      position: absolute;
      top: 56px;
      background-color: red;
      background: #ffffff;
      border-radius: 0px 0px 8px 8px;
      // opacity: 0.86;
      cursor: pointer;
      left: 50%;
      margin-left: -62px;
      visibility: hidden;
      &.show {
        visibility: visible;
      }
      &.listGLZX {
        margin-left: -100px;
      }
      div {
        line-height: 36px;
        width: 124px;
        color: #595959;
        font-size: 16px;

        &.itemActive {
          background: rgba(54, 143, 255, 0.8);
          color: #ffffff;
        }

        &.itemGLZX {
          width: 200px;
        }
      }
    }
  }
}
.right-login {
  position: absolute;
  right: 30px;
  color: #409eff;
}
// .login {
//   cursor: pointer;
//   font-size: 14px;
// }
@media screen and (max-width: 1560px) and (min-width: 1366px) {
  .app-header-menu {
    margin-left: 6px;
    .app-header-link {
      padding: 0px 16px 4px 16px !important;
    }
  }
  .app-header-container {
    padding: 0 24px;
    .app-header-title {
      margin-right: 24px;
    }
  }
}
@media screen and (max-width: 2000px) and (min-width: 1560px) {
  .app-header-menu {
    .app-header-link {
      padding: 0px 25px 4px 25px !important;
    }
  }
  .app-header-container {
    padding: 0 24px;
    .app-header-title {
      margin-right: 55px;
    }
  }
}
@media screen and (max-width: 1366px) {
  .left-nav {
    .logo {
      padding-right: 24px;
    }
  }
  .nav {
    li {
      padding: 0px 10px;
    }
  }
}
@media screen and (min-width: 1366px) and (max-width: 1560px) {
  .left-nav {
    .logo {
      padding-right: 30px;
    }
  }
  .nav {
    li {
      padding: 0px 11px;
    }
  }
}
@media screen and (max-width: 1330px) {
  .left-nav {
    .logo {
      padding-right: 14px;
      padding-left: 14px;
    }
  }
  .nav {
    li {
      width: auto;
      padding: 0px 16px;
    }
  }
}
</style>
